export default __webpack_public_path__ + "static/media/shengshi-logo2.0401e5ee.svg";